import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=bfe691e4&scoped=true&"
import script from "./dashboard-page.js?vue&type=script&lang=js&"
export * from "./dashboard-page.js?vue&type=script&lang=js&"
import style0 from "./dashboard-page.scss?vue&type=style&index=0&id=bfe691e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe691e4",
  null
  
)

component.options.__file = "dashboard-page.vue"
export default component.exports